import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from "../../services";
import {Subject} from "rxjs";

import {ComponentTitleService} from "../../services/componentTitle.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";

import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute} from "@angular/router";
import {Role} from "../models/role";
import {Module} from "../models/module";
import {Permission} from "../models/permission";
import {ModuleRolePermissionService} from "../services/moduleRolePermission.service";
import {ModuleRolePermission} from "../models/moduleRolePermission";
import {first} from "rxjs/operators";


@Component({
    templateUrl: './modulePermission.component.html',
    styleUrls: ['./modulePermission.component.scss']
})
export class ModulePermissionComponent implements OnDestroy, OnInit {

    roles: Role[];
    modules: Module[];
    permissions: Permission[];
    mrp: ModuleRolePermission[];
    assignedPermissions: boolean[] = [];

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private moduleRolePermissionService: ModuleRolePermissionService,
        public _matDialog: MatDialog,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Module permissions');

        this.translationLoader.loadTranslations(polish, english);

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.roles = this.route.snapshot.data.rolesData.items;
        this.modules = this.route.snapshot.data.modulesData.items;
        this.permissions = this.route.snapshot.data.permissionsData.items;
        this.mrp = this.route.snapshot.data.moduleRolePermissionsData.items;

        for (let i = 0; i < this.mrp.length; i++) {
            this.assignedPermissions[this.mrp[i].module.id+this.mrp[i].role.id + this.mrp[i].permission.id] = this.mrp[i].hasPermission;
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    hasPermission(module: Module, role: Role, permission: Permission): boolean {
        let hasPermission = false;

        for (let i = 0; i < this.mrp.length; i++) {
            if (
                this.mrp[i].module.id !== module.id ||
                this.mrp[i].role.id !== role.id ||
                this.mrp[i].permission.id !== permission.id
            ) {
                continue;
            }

            hasPermission = this.mrp[i].hasPermission;
        }

        return hasPermission;
    }

    updatePermission(module: Module, role: Role, permission: Permission, allow: boolean): void {
        this.moduleRolePermissionService.changePermissions(module, role, permission, allow)
            .pipe(first())
            .subscribe(
                data => {
                    this.assignedPermissions[module.id+ role.id + permission.id] = allow;
                },
                error => {
                    this.alertService.error(error);
                });
    }
}
